import React from 'react';
import styled from '@emotion/styled';
import colors, { white } from '../../../../theme/colors';
import { CurrencySymbols } from '../types';
import { isDarkMode } from '../../../../utils/helpers';
import breakpoints from '../../../../theme/material/breakpoints';

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const ContainerWrapper = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    display: 'inline-flex',
    padding: '11px 12px',
    alignItems: 'center',
    gap: 5,
    borderRadius: 15,
    border: `3px solid ${colors[theme].green.primary}`,
    background: white,
    position: 'absolute',
    right: 10,
    top: 30,
    opacity: 0.6,
    [breakpoints.up(769)]: {
      right: 20,
    },
  };
});

const IconWrapper = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    background: colors[theme].green.primary,
    borderRadius: 50,
    height: 30,
    width: 30,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const PassTextWrapper = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    color: colors[theme].green.primary,
    textAlign: 'center',
    fontSize: 22,
    fontStyle: 'normal',
    fontWeight: 700,
    letterSpacing: -0.44,
  };
});

interface Props {
  currencySymbols: CurrencySymbols;
}

const DashboardDiscoverModeOfferSentFlagOverlay: React.FC<Props> = ({ currencySymbols }) => {
  return (
    <ContainerWrapper>
      <IconWrapper>
        <span
          style={{
            color: white,
            fontSize: 20,
            fontWeight: 500,
          }}
        >
          {currencySymbols.currencyLabel}
        </span>
      </IconWrapper>
      <PassTextWrapper>OFFER!</PassTextWrapper>
    </ContainerWrapper>
  );
};

export default DashboardDiscoverModeOfferSentFlagOverlay;
